import * as React from "react";
import { Box, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useGetProjectBidsQuery } from "../../services/projectJob.service";
import { Project } from "../../types/project";
import { LoadingButton } from "@mui/lab";
import { Refresh } from "@mui/icons-material";
import { useGetProjectReviewsQuery } from "../../services/review.service";
import TableHireds from "./talentsPanel/TableHired";
import TableBids from "./talentsPanel/TableBids";
import TableInvites from "./talentsPanel/TableInvites";
import TableCancel from "./talentsPanel/TableCancel";
import { useGetProjectByIdQuery } from "../../services/project.service";
import TableMatched from "./talentsPanel/TableMatched";
import { useUILabel } from "../../hooks/useUILabel";

const ProjectTalentsPanel = ({ project }: { project: Project; }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const refreshLabel = useUILabel("common.refresh");
  const { refetch: refetchProject } = useGetProjectByIdQuery(project.id);
  const {
    data: jobs,
    isFetching,
    refetch,
  } = useGetProjectBidsQuery(project.id);

  const {
    data: reviews,
    isFetching: fetchingReviews,
    refetch: refetchReviews,
  } = useGetProjectReviewsQuery(project.id);

  const handleRefresh = () => {
    refetch();
    refetchProject();
    refetchReviews();
  };

  const hiredList = React.useMemo(
    () => jobs?.filter((it) => !!it.hired_at),
    [jobs]
  );
  const bidList = React.useMemo(
    () => jobs?.filter((it) => !it.hired_at),
    [jobs]
  );

  return (
    <Box
      sx={{
        px: { xs: 0, sm: 1.5, md: 0 },
        py: { xs: 1.5, md: 2 },
      }}
    >
      <Stack
        direction={isMobile ? "column" : "row"}
        justifyContent={isMobile ? "flex-start" : "flex-end"}
        alignItems={isMobile ? "stretch" : "center"}
        spacing={isMobile ? 1.5 : 0}
        sx={{ mb: { xs: 2, md: 3 } }}
      >
        <LoadingButton
          onClick={handleRefresh}
          size={isMobile ? "medium" : "large"}
          loading={isFetching}
          startIcon={<Refresh />}
          sx={{
            borderRadius: "12px",
            textTransform: "none",
            fontWeight: 600,
            px: { xs: 2.5, md: 3 },
            boxShadow: 2,
            "&:hover": {
              boxShadow: 4,
              transform: "translateY(-2px)",
            },
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          {refreshLabel}
        </LoadingButton>
      </Stack>
      <Stack spacing={4}>
        <TableHireds
          bids={hiredList || []}
          project={project}
          reviews={reviews || []}
          loading={isFetching}
        />
        <TableBids bids={bidList || []} project={project} />
        <TableInvites bids={bidList || []} project={project} />
        <TableMatched bids={bidList || []} project={project} />
        <TableCancel bids={bidList || []} project={project} />
      </Stack>
    </Box>
  );
};
export default ProjectTalentsPanel;
